<template>
  <div></div>
</template>

<script>
export default {
  computed: {
    defaultLanguage() {
      return this.$store.state.language.language;
    }
  },

  watch: {
    defaultLanguage() {
      this.setInput();
    }
  },

  methods: {
    setInput() {
      if (this.defaultLanguage === "Arabic") {
        $("input, textarea").each(function () {
          $(this).attr("dir", "rtl");
          $(this).removeClass("text-left");
          $(this).addClass("text-right");
        });
      } else {
        $("input, textarea").each(function () {
          $(this).attr("dir", "ltr");
          $(this).removeClass("text-right");
          $(this).addClass("text-left");
        });
      }
    }
  },

  mounted() {
      this.setInput();
  },
};
</script>